const appSettings = {
	backendUrl: "https://armybuilder-6c9d2-default-rtdb.firebaseio.com/",
	storageUrl: "https://ab-web-test.s3.us-east-1.amazonaws.com/",
	panelMinSize: 400,
	panelMaxSize: 600,
}


export default appSettings;